/**
 * Builds an FAQPage JSON-LD schema
 * @param {{
 *  faqs?: {
 *    q?: string | null,
 *    a?: string | null
 *  }[]} options Configuration options for the schema
 * @returns {Object | null} the schema object
 */
export function buildFAQPageSchema(options = {}) {
    const { faqs } = options

    if (!Array.isArray(faqs) || faqs.length === 0) {
        return null
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.q || "",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.a || ""
            }
        }))
    }

    return schema
}